var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareTurnaroundIcon = function SvgCompareTurnaroundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M7 6.25h6M7 13.75h6M7.75 6.25V8.5l1.688 1.875M12.25 13.75v-2.719l-1.687-1.594M7.75 13.75v-2.625l1.219-1.219M12.25 6.25V8.5l-.61.703-.304.352-.152.175"
  })));
};
export default SvgCompareTurnaroundIcon;